import { useMutation, useQueryClient } from '@tanstack/react-query';
import { surveysQueryKeys } from '../Constants/queryKeys';
import { bumpSurveyVersion } from '../Services/Surveys.service';
import { useActionToast } from '@/Hooks/useActionToast';

/**
 * Opens the next version, carrying the `reask` decision.
 *
 * `reask` is the whole difference between "corrigi um typo" and "quero perguntar de novo" (R3),
 * and it is a human call — which is why the BFF refuses the structural edit until it is made.
 */
export const useBumpSurveyVersion = () => {
  const queryClient = useQueryClient();
  const toast = useActionToast();

  return useMutation({
    mutationFn: ({ id, reask }: { id: string; reask: boolean }) => bumpSurveyVersion(id, reask),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: surveysQueryKeys.details() });
      queryClient.invalidateQueries({ queryKey: surveysQueryKeys.lists() });
    },
    onError: (error: Error) => {
      toast.failure('Não foi possível abrir a nova versão', error);
    },
  });
};
